import * as Sentry from '@sentry/react'
import posthog from 'posthog-js'

import { syncFailureReason } from './sync-errors'

/** A failure seen again within this window isn't reported again. */
export const REPORT_AGAIN_AFTER_MS = 10 * 60_000

const lastReported = new Map<string, number>()

/**
 * Reports a failed sync request (pull, push, photo upload) to Sentry and PostHog
 * with why it failed (`reason`). Syncs can run every few seconds, so the same
 * operation failing for the same reason is reported once every ten minutes, and
 * nothing while the phone knows it is offline.
 */
export function reportSyncFailure(operation: string, error: unknown): void {
  // Offline, any failure is expected
  if (globalThis.navigator?.onLine === false) return
  const reason = syncFailureReason(error)

  const key = `${operation}:${reason}`
  const now = Date.now()
  const previous = lastReported.get(key)
  if (previous !== undefined && now - previous < REPORT_AGAIN_AFTER_MS) return
  lastReported.set(key, now)

  // On the event only: Sentry.setExtras would stick to every later event
  const data = { operation, reason }
  Sentry.captureException(error, { tags: data })
  posthog.captureException(error, data)
}

/** Forgets what was reported; for tests. */
export function resetReportedSyncFailures(): void {
  lastReported.clear()
}
